

	import { Component } from 'vue-property-decorator';
	import { BaseAppView } from '@shared/views/BaseAppView';
	import firebase from 'firebase';

	@Component({})
	export default class Register extends BaseAppView {


		public email: string = '';
		public password: string = '';
		public rememberMe: boolean = true;

		public $refs!: {
			form: any,
		};
		public mounted() {
			if (this.$route.query?.noauth) {
				this.notification.error('You need to be logged in to do that');
			}
		}

		public async recover() {
			try {
				this.loading = true;
				const result = await firebase.auth().sendPasswordResetEmail(this.email);
				this.email = '';
				this.$router.push({ name: 'login' });
				this.notification.success('Please check your email for instructions on how to reset your password');
			} catch (err) {
				this.notification.error(err.message);
			} finally { 
				this.loading = false;
			}
		}


	}

